module.exports = __webpack_public_path__ + "assets/static/png/hosting-red.18ad1d53325894c82ee3969351f37bd4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/hosting-red.png
 ** module id = 508
 ** module chunks = 1
 **/